module.exports = __webpack_public_path__ + "img/mealreminder-minip.6529182c.png";